<template>
  <div>
    <chat-window
      height="100vh"
      :theme="theme"
      :styles="styles"
      :current-user-id="currentUserId"
      :load-first-room="singleRoom"
      :rooms-list-opened="false"
      :rooms="rooms"
      :messages="messages"
      :single-room="singleRoom"
      :loading-rooms="loadingRooms"
      :rooms-loaded="roomsLoaded"
      :messages-loaded="messagesLoaded"
      :show-search="true"
      :show-audio="false"
      :accepted-files="acceptedFiles"
      :message-actions="[]"
      :textarea-action-enabled="false"
      :emoji-picker-reaction-icon="null"
      :reply-close-icon="null"
      :show-emojis="true"
      :show-files="false"
      :show-new-messages-divider="true"
      @send-message="addMessage"
      @fetch-messages="onFetchMessages" />
  </div>
</template>

<script>
import Logs from '@/utils/logs'
import Const from '@/utils/const'
import { mapGetters } from 'vuex'
import { getFolio } from '@/api/customer'
import ChatWindow from 'vue-advanced-chat'
import 'vue-advanced-chat/dist/vue-advanced-chat.css'
import io from 'socket.io-client'
import 'moment/min/locales'

export default {
  name: 'Messages',
  components: {
    ChatWindow
  },
  data() {
    return {
      userToken: null,
      userId: null,
      deviceToken: null,
      name: null,
      roomId: '',
      theme: Const.chat.theme.LIGHT,
      folio: null,
      workspace: null,
      acceptedFiles: Const.chat.ACCEPTED_FILES,
      currentUserId: '',
      loadingRooms: true,
      roomsLoaded: true,
      messagesLoaded: false,
      task: null,
      rooms: [],
      singleRoom: true,
      messages: [],
      loading: {
        task: true
      },
      styles: {
        general: {
          colorSpinner: '#6e79ff'
        },
        message: {
          backgroundMe: '#6e79ff'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  beforeMount() {
    // Load id
    this.userToken = this.$route.query.token
    this.userId = this.$route.query.id
    // Load notifications
    this.deviceToken = this.$route.query.deviceToken
    // Load default name
    this.name = this.$route.query.name || 'Default'
    // Load theme
    if (this.$route.query.isDark) {
      this.theme = Const.chat.theme.DARK
    }
    // Optional, load task data
    this.folio = this.$route.query.folio
    this.workspace = { name: this.$route.query.workspace }
    // Load room
    this.roomId = this.folio ? (this.folio + (this.userId ? '_C' : '_D')) : null
    if (this.folio) {
      // Load task
      this.getTask(this.folio, null)
    } else {
      // Load socket
      this.initSocket()
    }
  },
  mounted() {
    Logs.normal(
      'TOKEN',
      this.token
    )
  },
  beforeDestroy() {
    this.disconnectSocket()
    Logs.normal(
      'Chat event:',
      'BEFORE_DESTROYED'
    )
  },
  methods: {
    connectSocket() {
      const query = {
        name: this.name
      }
      if (this.userId) {
        query['id'] = this.userId
      }
      if (this.deviceToken) {
        query['deviceToken'] = this.deviceToken
      }
      Logs.normal(
        'Chat env:',
        process.env.VUE_APP_CHAT_HOST
      )
      this.socket = io(process.env.VUE_APP_CHAT_HOST, {
        reconnection: true,
        transports: ['polling', 'websocket'],
        query: query,
        extraHeaders: {
          authorization: `${this.userToken || this.token}`
        }
      })
    },
    disconnectSocket() {
      if (this.socket) {
        this.socket.disconnect()
        this.socket.close()
      }
    },
    onMessageReceived(data) {
      const _data = JSON.parse(data)
      _data.avatar = Const.AVATAR.SUPPORT
      const message = this.loadMessage(_data)
      this.messagesLoaded = true
      this.messages.push(message)
    },
    onFetchMessages({ room, options }) {
      this.messagesLoaded = false
      this.socket.emit('join-chat', {
        room: room.roomId,
        ws: room.ws
      })
    },
    addMessage({ content, roomId, files, replyMessage }) {
      this.socket.emit('message', {
        room: roomId,
        message: content,
        ws: this.workspace.name
      })
      const currentDate = this.$moment()
      const data = {
        content,
        _id: `${currentDate}`,
        indexId: currentDate,
        senderId: this.currentUserId,
        roomId: this.roomId,
        username: this.name,
        timestamp: currentDate,
        avatar: Const.AVATAR.CLIENT
      }
      const message = this.loadMessage(data)
      Logs.normal(
        'CONTENT',
        message
      )
      this.messagesLoaded = true
      this.messages.push(message)
    },
    loadMessage(_data) {
      const msg = {
        _id: _data._id,
        indexId: _data.indexId,
        content: _data.content,
        senderId: _data.senderId,
        username: _data.username,
        avatar: _data.avatar,
        date: this.$moment(new Date(_data.timestamp)).format('dddd, MMMM DD YYYY'),
        timestamp: this.$moment(new Date(_data.timestamp)).format('h:mm a'),
        system: false,
        saved: true,
        distributed: true,
        new: _data.new ? false : _data.new,
        seen: true,
        deleted: false,
        disableActions: true,
        disableReactions: true,
        room: _data.roomId
      }
      return msg
    },
    onHistory(data) {
      if (Array.isArray(data.chat) && data.chat.length > 0) {
        const messagesChat = []
        for (let i = data.chat.length - 1; i >= 0; i--) {
          const parsedObject = JSON.parse(data.chat[i])
          const _messageChat = {
            _id: parsedObject._id,
            indexId: parsedObject.indexId,
            content: parsedObject.content,
            senderId: parsedObject.senderId,
            username: parsedObject.username,
            avatar: parsedObject.avatar,
            room: parsedObject.room,
            date: this.$moment(new Date(parsedObject.timestamp)).format('dddd, MMMM DD YYYY'),
            timestamp: this.$moment(new Date(parsedObject.timestamp)).format('h:mm a'),
            system: false,
            saved: true,
            distributed: true,
            seen: true,
            deleted: false,
            disableActions: true,
            disableReactions: true
          }
          messagesChat.push(_messageChat)
        }
        this.messages = messagesChat
      }
      this.messagesLoaded = true
    },
    async getTask(folio, workspaceId) {
      this.loading.task = true
      await getFolio(folio, workspaceId)
        .then(function(response) {
          if (response.workspace) {
            Logs.normal(
              'Task data:',
              response
            )
            this.task = response
            if (this.task && this.task.customer) {
              this.currentUserId = this.task.customer._id
              Logs.normal(
                'CurrentId:',
                this.currentUserId
              )
            }
            // Load dataf
            Logs.normal(
              'LOAD_DATA:',
              response.data
            )
            this.initSocket()
          } else {
            this.$message({
              message: this.$t('general.invalidData'),
              type: 'error'
            })
          }
          this.loading.task = false
        }.bind(this))
        .catch(function(error) {
          Logs.normal(
            'GET_TASK_ERROR',
            error
          )
          this.$message({
            message: error,
            type: 'error'
          })
          this.loading.task = false
        }.bind(this))
    },
    onInfo(data) {
      if (!this.userId) {
        this.currentUserId = data.id
      }
      Logs.normal(
        'ON_INFO:',
        data
      )
    },
    onChats(data) {
      Logs.normal(
        'ON_CHATS:',
        data
      )
      const roomsList = []
      let isNewChat = true
      if (Array.isArray(data) && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          if (this.folio && this.folio.includes(data[i].roomId)) {
            isNewChat = false
          }
          roomsList.push({
            roomId: data[i].roomId,
            roomName: data[i].roomId,
            avatar: data[i].avatar,
            unreadCount: data[i].unreadCount,
            ws: data[i].ws,
            index: data[i].index,
            lastMessage: this.loadMessage(data[i].lastMessage) || null,
            users: data.users || []
          })
        }
        this.singleRoom = false
        this.rooms = roomsList
      } else {
        this.singleRoom = true
        this.rooms = [
          {
            roomId: this.roomId,
            roomName: this.roomId,
            unreadCount: 0,
            ws: this.workspace.name,
            index: 0,
            lastMessage: null,
            users: []
          }
        ]
      }
      this.loadingRooms = false
      if (isNewChat && this.roomId) {
        Logs.normal(
          'IS_NEW_CHAT:',
          this.roomId + ', ' + this.workspace.name
        )
        this.socket.emit('join-chat', {
          room: this.roomId,
          ws: this.workspace.name
        })
      }
    },
    initSocket() {
      this.connectSocket()
      this.socket.on('connect', (resp) => {
        Logs.normal(
          'SOCKET_CONNECT:'
        )
      })
      this.socket.on('info', this.onInfo)
      this.socket.on('message', this.onMessageReceived)
      this.socket.on('history', this.onHistory)
      this.socket.on('chats', this.onChats)
    }
  }
}
</script>
<style>
.vac-svg-button.vac-add-icon {
  display: none;
}
</style>
